import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';

import { PostV2AuthSignupBody, TShortUserInfoDto, useAvApi } from '@app-velocity/av-api-v2';

export const useRegisterMutation = () => {
  const { auth } = useAvApi();

  return useMutation<TShortUserInfoDto, AxiosError, PostV2AuthSignupBody>({
    mutationKey: ['users', 'register'],
    mutationFn: async (userRegisterDto) => {
      const { data } = await auth.postV2AuthSignup(
        userRegisterDto
      );

      return data;
    },

  });
};
